import { render, staticRenderFns } from "./listParceladas.vue?vue&type=template&id=3aaafb98"
import script from "./listParceladas.ts?vue&type=script&lang=js&external"
export * from "./listParceladas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aaafb98')) {
      api.createRecord('3aaafb98', component.options)
    } else {
      api.reload('3aaafb98', component.options)
    }
    module.hot.accept("./listParceladas.vue?vue&type=template&id=3aaafb98", function () {
      api.rerender('3aaafb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/contareceber/listParceladas.vue"
export default component.exports